export { PipesModule } from './lib/pipes.module';
export * from './lib/pipes/currency-filter.pipe';
export * from './lib/pipes/format.pipe';
export { DocumentPipeService } from './lib/services/document-pipe.service';
